module.exports = __webpack_public_path__ + "static/media/zr_2_13.4eb3e736.png";